import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CurrencyFormatPipe } from '@core/pipes/currency-format.pipe';
import { DateFormatPipe } from '@core/pipes/date-format.pipe';
import { AgentService } from '@core/services/agent.service';
import { AlertService } from '@core/services/alert.service';
import { CommonService } from '@core/services/common.service';
import { CorrespondenceService } from '@core/services/correspondence.service';
import { DataService } from '@core/services/data.service';
import { PolicyService } from '@core/services/policy.service';
import { TranslateService } from '@ngx-translate/core';
import { CpcPayment } from '@shared/models/cpc-payment';
import { PolicyDetailComponent } from '../policy-detail.component';
import { LoadingService } from '@core/services/loading.service';
import moment from 'moment';
import { InsuredTripTravelCardRequest } from '@shared/models/policies/detail/insured-trip/insured-trip-travel-card-request';
import { InsuredTripTravelCardResponse } from '@shared/models/policies/detail/insured-trip/insured-trip-travel-card-response';
import { TravelMemberService } from '@core/services/travel-member.service';
import { InsuredTripTravelCardRequestMultiple } from '@shared/models/policies/detail/insured-trip/insured-trip-travel-card-request-multiple';
import { GreenCardRequest } from '@shared/models/policies/detail/green-card-request';
import { GreenCardResponse } from '@shared/models/policies/detail/green-card-response';
import { MaInsuranceCar, MaInsuranceTravel } from '@shared/models/ma-insurance';
import { LOB } from '@shared/models/LOB';
import { ClaimMyData } from 'app/models/claim-my-data';
import { ClaimService } from '@core/services/claim.service';

@Component({
    selector: 'app-policy-detail-individual',
    templateUrl: './policy-detail-individual.component.html',
    styleUrls: ['./policy-detail-individual.component.scss'],
    standalone: false
})
export class PolicyDetailIndividualComponent extends PolicyDetailComponent implements OnInit {

    public LOB = new LOB();
    public canBeCanceled = false;
    private allowedCancelLobs = {
        'CAR-INSURANCE': [3, 8],
        'HOME-INSURANCE': [9]
    };

    public responsibility: string = '';
    constructor(
        public commonService: CommonService,
        protected dataService: DataService,
        protected policyService: PolicyService,
        protected route: ActivatedRoute,
        protected correspondenceService: CorrespondenceService,
        protected translateService: TranslateService,
        protected alertService: AlertService,

        private agentService: AgentService,
        private dateFormatPipe: DateFormatPipe,
        private currencyFormatPipe: CurrencyFormatPipe,
        protected loadingService: LoadingService,
        private travelMemberService: TravelMemberService,
        private claimService: ClaimService
    ) {
        super(commonService, dataService, policyService, route, correspondenceService, translateService, alertService, loadingService);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.policyService.getPolicyDetail(this.policyState, this.policyNumber).subscribe(res => {
            this.policy = res.policy;
            this.maInsurance = res.maInsurance;

            if ([1160, 1161, 1042, 1043, 1044].includes(this.policy.packageId)) {
                this.responsibility = '_responsibility';
            }

            if (!res.premiumList.allDataFlag) {
                // show ALERT
            }

            this.canBeCanceled = this.policyState == 'active' && this.allowedCancelLobs[this.policy.detailTypeIdentifier] != undefined && this.allowedCancelLobs[this.policy.detailTypeIdentifier].includes(this.policy.lineOfBusinessId);
            !this.policy.policyNumber.startsWith('705') &&
                !this.policy.policyNumber.startsWith('805');

            // filter upcoming premiums
            this.upcomingPremiumList = res.premiumList.list.filter(x => !x.matchDate)
                .sort((a, b) => new Date(a.maturityDate).getTime() - new Date(b.maturityDate).getTime());

            this.pastPremiumList = res.premiumList.list.filter(x => !!x.matchDate)
                .sort((a, b) => new Date(b.maturityDate).getTime() - new Date(a.maturityDate).getTime());

            this.downLoadDocumentUrl = this.dataService.environmentConfig.downloadDocumentUrl;

            this.loadDocuments();
            if (this.policy.downloadAllStatus != null && this.policy.downloadAllStatus.status == 'in-progress') {
                this.CheckStatus();
            }

            this.agentService.getAgentsForPolicy(this.policy.policyNumber).subscribe(agents => {
                let tmpAgents = {};
                for (let i = 0; i < agents.list.length; i++) {

                    if (agents.list[i].agentChannel !== 'INT' && agents.list[i].agentChannel !== 'CC' && agents.list[i].agentChannel !== 'UNK') {
                        if (tmpAgents[agents.list[i].agentId] == undefined) {
                            agents.list[i].cnt = 1;
                            agents.list[i].dateBeginNumber = new Date(agents.list[i].dateBegin).getTime();

                            if (agents.list[i].agentChannel == 'FO') {
                                agents.list[i].agentMobilAgn = '+421 2 50 122 222';
                                agents.list[i].agentEmailAgn = 'allianz@allianz.sk';
                            }
                            tmpAgents[agents.list[i].agentId] = agents.list[i];
                        } else {
                            tmpAgents[agents.list[i].agentId].cnt++;

                            let t = new Date(agents.list[i].dateBegin).getTime();
                            if (tmpAgents[agents.list[i].agentId].dateBeginNumber < t) {
                                tmpAgents[agents.list[i].agentId].dateBegin = t;
                            }
                        }

                    }
                }

                this.agents = Object.values(tmpAgents);

                this.agents.sort(function (a, b) {
                    if ((b.cnt - a.cnt) < 0) {
                        return -1;
                    } else if ((b.cnt - a.cnt) > 0) {
                        return 1;
                    } else {
                        return b.dateBeginNumber - a.dateBeginNumber;
                    }
                });
            });

            if (this.upcomingPremiumList.length) {

                this.upcomingPaymentList = this.upcomingPremiumList.map(premium => {

                    let o = {
                        variant: premium.status,
                        badgeVariant: this.paymentStatusVariant[premium.status],
                        due: this.dateFormatPipe.transform(premium.maturityDate),
                        amount: this.currencyFormatPipe.transform(premium.amount.toString(), premium.currency),
                        gatewayPaymentUrl: premium.gatewayPaymentUrl,
                        canBePayed: premium.canBePayed
                    };

                    this.translateService.get('payment-status').subscribe(t => {
                        if (t[premium.status])
                            o['variant'] = t[premium.status];
                    });

                    return o as CpcPayment;
                });
            }

            if (this.pastPremiumList.length) {
                this.pastPaymentList = this.pastPremiumList.map(premium => {
                    let o = {
                        variant: premium.status,
                        badgeVariant: this.paymentStatusVariant[premium.status],
                        due: this.dateFormatPipe.transform(premium.maturityDate),
                        date: this.dateFormatPipe.transform(premium.matchDate),
                        amount: this.currencyFormatPipe.transform(premium.amount.toString(), premium.currency),
                        method: '',
                    };

                    this.translateService.get('payment-status').subscribe(t => {
                        if (t[premium.status])
                            o['variant'] = t[premium.status];
                    });

                    this.translateService.get(this.paymentSources.findById(premium.paymentMethodId)?.textToTranslate).subscribe(t => {
                        o.method = t;
                    });

                    return o as CpcPayment;
                });
            }

        });
    }

    // TODO Remove ?
    paymentsTabChanged($event): void { }

    claimMyData(policyNumber: string, detailTypeIdentifier: string, lob: number) {
        this.gtm();
        this.claimService.getMyClaimData(policyNumber, detailTypeIdentifier).subscribe((claimMyData: ClaimMyData) => {
            if (claimMyData && claimMyData.redirectUrl) {
                this.claimService.postClaimData(claimMyData).subscribe(x => {
                    window.open(claimMyData.redirectUrl, 'blank');
                });
            }

            if (!claimMyData || claimMyData.redirectUrl == null) {
                let url = this.translateService.instant('file-a-claim.' + this.commonService.env + '.lob_' + lob);
                window.open(url, 'blank');
            }
        });
    }
}
